/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import MechPaylineManager from '../Library/Scripts/Paylines/MechPaylineManager';
import PaylineManager from '../Library/Scripts/Paylines/PaylineManager';
import PlaybarSwitcher from '../Library/Scripts/Playbar/PlaybarSwitcher';
import HTMLSplashScreenComponent from '../Library/Scripts/StartUp/HTMLSplashScreenComponent';
import SplashScreenComponent from '../Library/Scripts/StartUp/SplashScreenComponent';
import ClassUtil from '../Library/Scripts/Utility/ClassUtil';
import ComponentReference from '../Library/Scripts/Utility/Component/ComponentReference/ComponentReference';
import ConfiguratorBaseComponent from '../Library/Scripts/Utility/Component/Configurator/ConfiguratorBaseComponent';
import { ContextKey } from '../Library/Scripts/Utility/Component/Configurator/ContextKey';
import PopupSwitcher from '../Library/Scripts/Utility/Component/Popup/PopupSwitcher';

const {ccclass, property} = cc._decorator;

@ccclass
export default class ConfiguratorComponent extends ConfiguratorBaseComponent
{
    protected SetBindings(): void
    {
        ComponentReference.MapComponent(ClassUtil.getName(PaylineManager), MechPaylineManager);
        ComponentReference.MapComponent(ClassUtil.getName(SplashScreenComponent), HTMLSplashScreenComponent);
        ComponentReference.MapComponent(ContextKey.PLAYBAR, PlaybarSwitcher);
        ComponentReference.MapComponent(ContextKey.POPUP_MANAGER, PopupSwitcher);
    }
}
